var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-bar"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"container"},[_c('account-stats-slider',_vm._b({},'account-stats-slider',_vm.selectProps,false))],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }